export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6806.b20c4c4f.jpg";